import { Outlet } from 'react-router-dom'
import { BannedAccountGate } from '@/components/auth/banned-account-gate'
import { Header } from './header'
import { Sidebar } from './sidebar'
import { ExoclickAd } from '@/components/ads/exoclick-ad'
import { ExoclickStickyBanner } from '@/components/ads/exoclick-sticky-banner'

export function MainLayout() {
  return (
    <BannedAccountGate>
      <div className="min-h-screen bg-background">
        <Header />
        <div className="flex min-w-0">
          <Sidebar />
          <main className="min-h-[calc(100vh-4rem)] w-full min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
        <ExoclickAd />
        <ExoclickStickyBanner />
      </div>
    </BannedAccountGate>
  )
}
